// Lightweight namespaced dev logger.
//
// Default behavior:
//   - production build: every log/warn is a no-op (NODE_ENV gate).
//   - dev build, no flag set: silent.
//   - dev build with localStorage flag set: emits prefixed logs for the
//     selected namespaces only.
//
// Toggle in the browser console (no rebuild needed):
//   localStorage.setItem('okoyl_debug', 'saga,combat')   // multi-namespace
//   localStorage.setItem('okoyl_debug', '*')             // everything
//   localStorage.removeItem('okoyl_debug')               // back to silent
//
// console.error is intentionally NOT routed through here — real errors
// should always be visible, in any environment.

const isDev = process.env.NODE_ENV === 'development';

const readFlag = () => {
    if (!isDev) return null;
    try {
        return (typeof window !== 'undefined' && window.localStorage)
            ? window.localStorage.getItem('okoyl_debug')
            : null;
    } catch (_) {
        return null;
    }
};

const isEnabled = (ns) => {
    const flag = readFlag();
    if (!flag) return false;
    if (flag === '*') return true;
    return flag.split(',').map(s => s.trim()).includes(ns);
};

const make = (ns) => ({
    log: (...args) => { if (isEnabled(ns)) console.log(`[${ns}]`, ...args); },
    warn: (...args) => { if (isEnabled(ns)) console.warn(`[${ns}]`, ...args); },
});

export const log = {
    saga: make('saga'),
    reducer: make('reducer'),
    ui: make('ui'),
    auth: make('auth'),
    combat: make('combat'),
};
